// extracted by mini-css-extract-plugin
var _1 = "LCYYt";
export { _1 as "base" }
